<template>
    <div
        class="inline-flex items-center border rounded justify-between"
        :class="{ 'opacity-50': disabled }"
    >
        <button
            class="btn btn-sm px-2"
            type="button"
            :disabled="disabled || internalValue <= minValue"
            @click="decrement"
        >
            ➖
        </button>

        <output
            class="quantity-output border-left border-right"
            role="spinbutton"
            tabindex="0"
            :aria-valuemin="minValue"
            :aria-valuemax="maxValue"
            :aria-valuenow="internalValue"
        >
            <bdi>{{ internalValue }}</bdi>
        </output>

        <button
            class="btn btn-sm px-2"
            type="button"
            :disabled="disabled || internalValue >= maxValue"
            @click="increment"
        >
            ➕
        </button>
    </div>
</template>

<script>
export default {
    name: "QuantitySpinner",

    props: {
        value: {
            type: [Number, String],
            required: true
        },
        min: {
            type: [Number, String],
            default: 0
        },
        max: {
            type: [Number, String],
            default: 100
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            internalValue: this.parseNumber(this.value)
        };
    },

    computed: {
        minValue() {
            return this.parseNumber(this.min);
        },
        maxValue() {
            return this.parseNumber(this.max);
        }
    },

    watch: {
        value(val) {
            const parsed = this.parseNumber(val);
            if (parsed !== this.internalValue) {
                this.internalValue = parsed;
            }
        }
    },

    methods: {
        parseNumber(val) {
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        },

        clamp(val) {
            return Math.min(this.maxValue, Math.max(this.minValue, val));
        },

        increment() {
            if (this.disabled) return;
            const next = this.clamp(this.internalValue + 1);
            this.update(next);
        },

        decrement() {
            if (this.disabled) return;
            const next = this.clamp(this.internalValue - 1);
            this.update(next);
        },

        update(val) {
            this.internalValue = val;
            this.$emit("input", val);
            this.$emit("change", val);
        }
    }
};
</script>

<style scoped>
.quantity-output {
    font-size: inherit;
    outline: 0;
    border: 0;
    background-color: transparent;
    width: auto;
    margin: 0;
    padding: 0 0.25rem;
    min-width: 1.5rem;
    text-align: center;
}
</style>
